module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-embed": "static-1.25619",
      "conversations-internal-schema": "static-1.12331",
      "head-dlb": "static-1.4702",
      "hs-test-utils": "static-1.7686",
      "hubspot-url-utils": "static-1.3869",
      "HubStyleTokens": "static-2.11128",
      "I18n": "static-7.1542",
      "jasmine-runner": "static-1.6157",
      "quartz": "static-1.6587",
      "react": "static-7.176",
      "sinon": "static-1.9",
      "StyleGuideUI": "static-3.482",
      "webpack-env": "static-1.54",
      "visitor-ui-component-library": "static-1.5831",
      "enviro": "static-4.371",
      "hs-promise-rejection-tracking": "static-1.5234",
      "PortalIdParser": "static-2.334",
      "raven": "static-3.5564",
      "raven-hubspot": "static-1.5871",
      "bend-plugin-trellis-migration": "static-1.3139",
      "moment": "static-3.26",
      "cv-backend-services": "static-1.1459",
      "hub-http": "static-1.5872",
      "immutable": "static-2.19",
      "immutable-less": "static-1.4358",
      "quartz-config": "static-1.365",
      "quartz-core": "static-1.5806",
      "transmute": "static-2.85",
      "HeadJS": "static-2.691",
      "react-dom": "static-7.85",
      "foundations-components": "static-1.7319",
      "framer-motion": "static-1.65",
      "hs-test-utils-bend-plugin": "static-1.2797",
      "msw": "static-1.39",
      "react-redux": "static-7.65",
      "redux": "static-4.16",
      "testing-library": "static-1.145",
      "foundations-theming": "static-1.4106",
      "i18n-data": "static-1.215",
      "metrics-js": "static-1.9339",
      "moment-timezone": "static-5.76",
      "react-utils": "static-2.5089",
      "jasmine": "static-4.4035",
      "history": "static-4.47",
      "csstype": "static-1.50",
      "hoist-non-react-statics": "static-3.9",
      "PatternValidationJS": "static-1.437",
      "react-aria": "static-1.59",
      "styled-components": "static-2.83",
      "UIComponents": "static-3.8075",
      "visitor-ui-component-library-icons": "static-1.5642",
      "bender-build-tools": "static-1.2823",
      "rpc-client-utils": "static-1.4308",
      "ts-schema": "static-1.3816",
      "hs-lodash": "static-4.45",
      "immer": "static-1.33",
      "dispatcher": "static-1.129",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.771",
      "hubspotter-http": "static-1.4391",
      "icons": "static-2.614",
      "mobile-manifest-mixins": "static-1.464",
      "quartz-auth": "static-1.262",
      "quartz-head": "static-1.252",
      "quartz-i18n": "static-1.262",
      "quartz-test": "static-1.262",
      "quick-fetch": "static-1.3641",
      "react-rhumb": "static-1.16336",
      "react-router-dom": "static-5.26",
      "usage-tracker-container": "static-1.7030",
      "ui-fonts": "static-1.390",
      "bend-plugin-foundations-components": "static-1.3588",
      "floating-ui": "static-1.49",
      "foundations-assets": "static-1.4535",
      "foundations-theming-specialty": "static-1.1822",
      "hs-story-utils": "static-1.9131",
      "react-select-plus": "static-1.65",
      "react-virtualized": "static-2.92",
      "tanstack-table": "static-1.48",
      "trellis-assets": "static-1.986",
      "ui-images": "static-2.1063",
      "bend-plugin-foundations-theming": "static-1.2589",
      "foundations-theming-base": "static-1.3091",
      "stylex": "static-1.25",
      "classnames": "static-2.10",
      "cssUtils": "static-1.699",
      "HubStyle": "static-2.11436",
      "sassPrefix": "static-1.150",
      "hub-http-shared-msw-handlers": "static-1.9224",
      "hubspotter-http-shared-msw-handlers": "static-1.9222",
      "usage-tracker-core": "static-1.6890",
      "react-input-autosize": "static-2.17"
    },
    "depPathPrefixes": {
      "conversations-embed": "/conversations-embed/static-1.25619",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12331",
      "head-dlb": "/head-dlb/static-1.4702",
      "hs-test-utils": "/hs-test-utils/static-1.7686",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3869",
      "HubStyleTokens": "/HubStyleTokens/static-2.11128",
      "I18n": "/I18n/static-7.1542",
      "jasmine-runner": "/jasmine-runner/static-1.6157",
      "quartz": "/quartz/static-1.6587",
      "react": "/react/static-7.176",
      "sinon": "/sinon/static-1.9",
      "StyleGuideUI": "/StyleGuideUI/static-3.482",
      "webpack-env": "/webpack-env/static-1.54",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5831",
      "enviro": "/enviro/static-4.371",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5234",
      "PortalIdParser": "/PortalIdParser/static-2.334",
      "raven": "/raven/static-3.5564",
      "raven-hubspot": "/raven-hubspot/static-1.5871",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3139",
      "moment": "/moment/static-3.26",
      "cv-backend-services": "/cv-backend-services/static-1.1459",
      "hub-http": "/hub-http/static-1.5872",
      "immutable": "/immutable/static-2.19",
      "immutable-less": "/immutable-less/static-1.4358",
      "quartz-config": "/quartz-config/static-1.365",
      "quartz-core": "/quartz-core/static-1.5806",
      "transmute": "/transmute/static-2.85",
      "HeadJS": "/HeadJS/static-2.691",
      "react-dom": "/react-dom/static-7.85",
      "foundations-components": "/foundations-components/static-1.7319",
      "framer-motion": "/framer-motion/static-1.65",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2797",
      "msw": "/msw/static-1.39",
      "react-redux": "/react-redux/static-7.65",
      "redux": "/redux/static-4.16",
      "testing-library": "/testing-library/static-1.145",
      "foundations-theming": "/foundations-theming/static-1.4106",
      "i18n-data": "/i18n-data/static-1.215",
      "metrics-js": "/metrics-js/static-1.9339",
      "moment-timezone": "/moment-timezone/static-5.76",
      "react-utils": "/react-utils/static-2.5089",
      "jasmine": "/jasmine/static-4.4035",
      "history": "/history/static-4.47",
      "csstype": "/csstype/static-1.50",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "react-aria": "/react-aria/static-1.59",
      "styled-components": "/styled-components/static-2.83",
      "UIComponents": "/UIComponents/static-3.8075",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5642",
      "bender-build-tools": "/bender-build-tools/static-1.2823",
      "rpc-client-utils": "/rpc-client-utils/static-1.4308",
      "ts-schema": "/ts-schema/static-1.3816",
      "hs-lodash": "/hs-lodash/static-4.45",
      "immer": "/immer/static-1.33",
      "dispatcher": "/dispatcher/static-1.129",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.771",
      "hubspotter-http": "/hubspotter-http/static-1.4391",
      "icons": "/icons/static-2.614",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.464",
      "quartz-auth": "/quartz-auth/static-1.262",
      "quartz-head": "/quartz-head/static-1.252",
      "quartz-i18n": "/quartz-i18n/static-1.262",
      "quartz-test": "/quartz-test/static-1.262",
      "quick-fetch": "/quick-fetch/static-1.3641",
      "react-rhumb": "/react-rhumb/static-1.16336",
      "react-router-dom": "/react-router-dom/static-5.26",
      "usage-tracker-container": "/usage-tracker-container/static-1.7030",
      "ui-fonts": "/ui-fonts/static-1.390",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3588",
      "floating-ui": "/floating-ui/static-1.49",
      "foundations-assets": "/foundations-assets/static-1.4535",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1822",
      "hs-story-utils": "/hs-story-utils/static-1.9131",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-virtualized": "/react-virtualized/static-2.92",
      "tanstack-table": "/tanstack-table/static-1.48",
      "trellis-assets": "/trellis-assets/static-1.986",
      "ui-images": "/ui-images/static-2.1063",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2589",
      "foundations-theming-base": "/foundations-theming-base/static-1.3091",
      "stylex": "/stylex/static-1.25",
      "classnames": "/classnames/static-2.10",
      "cssUtils": "/cssUtils/static-1.699",
      "HubStyle": "/HubStyle/static-2.11436",
      "sassPrefix": "/sassPrefix/static-1.150",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9224",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9222",
      "usage-tracker-core": "/usage-tracker-core/static-1.6890",
      "react-input-autosize": "/react-input-autosize/static-2.17"
    },
    "project": "conversations-embed",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};